import { SidenavLayoutComponent } from '@alfresco/adf-core';
import { NavBarGroupRef } from '@alfresco/adf-extensions';
import {
  Component,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import { Store } from '@ngrx/store';
import { Subject, Subscription } from 'rxjs';
import { AppStore } from '../../store';
import { NodeInfoService, WkCoreExtensionService } from '../../services';
import { AppService } from '@adw/projects/aca-shared/src/public-api';
import { debounceTime, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { getSideNavState } from '@adw/projects/aca-shared/store/src/public-api';

@Component({
  selector: 'wk-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.custom.scss'],
  encapsulation: ViewEncapsulation.None,
  host: { class: 'app-sidenav' },
  standalone: false,
})
export class WkSidenavComponent implements OnInit, OnChanges, OnDestroy {
  @Input()
  mode: 'collapsed' | 'expanded' = 'expanded';
  isSite = false;
  @Input()
  data: SidenavLayoutComponent;

  public groups: Array<NavBarGroupRef> = [];
  private readonly _onDestroy$: Subject<boolean> = new Subject<boolean>();
  private readonly subscriptions: Subscription[] = [];

  constructor(
    private readonly store: Store<AppStore>,
    private readonly extensions: WkCoreExtensionService,
    private readonly nodeService: NodeInfoService,
    private readonly appService: AppService
  ) {}

  public ngOnInit(): void {
    this.store
      .select(getSideNavState)
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        takeUntil(this._onDestroy$)
      )
      .subscribe(() => {
        this.groups = this.extensions.getApplicationNavigation(
          this.extensions.navbar
        );
      });
    this.appService.toggleAppNavBar$
      .pipe(takeUntil(this._onDestroy$))
      .subscribe(() => {
        this.data.toggleMenu();
      });
  }

  public ngOnChanges(): void {
    this.subscriptions.push(
      this.nodeService.getSiteFlag().subscribe((siteFlag) => {
        this.isSite = siteFlag;
      })
    );
  }

  // isLoggedIn with provider is no more required

  public trackById(_: number, obj: { id: string }): string {
    return obj.id;
  }

  public ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => subscription.unsubscribe());
    this._onDestroy$.next(true);
    this._onDestroy$.complete();
  }

  public toggleClick(): void {
    this.toggleNavBar();
  }

  private toggleNavBar(): void {
    this.appService.toggleAppNavBar$.next();
    this.appService.appNavNarMode$.next(
      this.data.templateContext.isMenuMinimized() ? 'collapsed' : 'expanded'
    );
  }
}
